module.exports = __webpack_public_path__ + "static/media/star-exclamation.0260fea3.svg";